

/* global chrome */



import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import api from "../../core/axios/axiosInstance";
import { fetchProfile } from "../../core/data/redux/slices/ProfileSlice";
import { useDispatch, useSelector } from "react-redux";

const Login = () => {
  const navigate = useNavigate();
  const route = all_routes;
  const dispatch = useDispatch();

  // Standard login states
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  // Magic link states
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [magicEmail, setMagicEmail] = useState("");
  const [magicLink, setMagicLink] = useState("");
  const [magicLoading, setMagicLoading] = useState(false);
  const [magicMessage, setMagicMessage] = useState("");

  const fetchUserError = useSelector((state) => state.profile.error);

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  // Redirect if logged in
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && !fetchUserError) {
      navigate(route.dialer);
    }
  }, []);
  // Standard login functionality
 const handleLogin = async (e) => {
  e.preventDefault();
  setMessage("");
  setIsLoading(true);

  console.log("[VOYCELL][LOGIN] Login started");

  try {
    const payload = { email, password };
    console.log("[VOYCELL][LOGIN] Payload:", payload);

    const response = await api.post("user/login", payload);
    console.log("[VOYCELL][LOGIN] API response:", response.data);

    if (response.data.status === "success") {
      const token = response.data.data.token;

      console.log("[VOYCELL][LOGIN] Token received:", token);

      // Save for website
      localStorage.setItem("token", token);
      console.log("[VOYCELL][LOGIN] Token saved to localStorage");

      // Send to extension
  try {
  // Only try if chrome.runtime is available
  if (chrome && chrome?.runtime) {
    console.log("[VOYCELL][LOGIN] Sending token to extension background");

    chrome.runtime.sendMessage(
      "bbpbhclagighilpakeadlgkmlhacnmlf",
      { type: "SET_TOKEN", token },
      (response) => {
        if (chrome.runtime.lastError) {
          console.warn("[VOYCELL][LOGIN] Extension message error:", chrome.runtime.lastError);
        } else {
          console.log("[VOYCELL][LOGIN] Token sent successfully:", response);
        }
      }
    );
  } else {
    console.log("[VOYCELL][LOGIN] Chrome extension not detected. Skipping token send.");
  }
} catch (err) {
  console.error("[VOYCELL][LOGIN] Failed to send token to extension:", err);
}



      setMessage(response.data.message);

      await dispatch(fetchProfile());
      console.log("[VOYCELL][LOGIN] Profile fetched");

      if (response.data.data.role === "companyAdmin") {
        console.log("navigating to company admin");
        
        navigate(route.dialer);
      } else {
        console.log("navigating to agent dialer");

        navigate(route.agentDialer);
      }
    }
  } catch (error) {
    console.error("[VOYCELL][LOGIN] Error:", error);
    setMessage(error?.response?.data?.message || "Login failed");
  } finally {
    setIsLoading(false);
    console.log("[VOYCELL][LOGIN] Login flow finished");
  }
};


  // ================================
  // MAGIC LINK → STEP 1: SEND EMAIL
  // ================================
  const handleSendMagicLink = async () => {
    setMagicLoading(true);
    setMagicMessage("");

    try {
      console.log(magicEmail, "magic email");

      const res = await api.post("/user/generateMagicLink", {
        email: magicEmail,
      });
      console.log(res.data, "respomnse from generate magic link");

      setMagicMessage(res.data.message || "Magic link sent!");
      setShowEmailModal(false);
      setShowLinkModal(true);
    } catch (error) {
      setMagicMessage(
        error?.response?.data?.message || "Unable to send magic link.",
      );
    } finally {
      setMagicLoading(false);
    }
  };

  // =================================
  // MAGIC LINK → STEP 2: VERIFY LINK
  // =================================
  const handleVerifyMagicLink = async () => {
    setMagicLoading(true);
    setMagicMessage("");
    console.log(magicLink, "magicLink");

    try {
      const res = await api.post("/user/login/magic-link", { magicLink });
      console.log(res, "response from magic lonk login");

      localStorage.setItem("token", res.data.data.token);

      await dispatch(fetchProfile());

      navigate(route.dialer);
    } catch (error) {
      setMagicMessage(error?.response?.data?.message || "Invalid magic link.");
    } finally {
      setMagicLoading(false);
    }
  };

  return (
    <div className="account-content">
      <div className="d-flex flex-wrap w-100 vh-100 overflow-hidden">
        <div className="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 w-50 bg-backdrop">
          <form className="flex-fill" onSubmit={handleLogin}>
            <div className="mx-auto mw-450">
              <div className="text-center mb-4">
                <ImageWithBasePath
                  src="assets/img/voycell-logo.webp"
                  className="img-fluid"
                  alt="Logo"
                />
              </div>

              <div className="mb-4">
                <h4>Sign In</h4>
                <p>Access the Voycell panel using your email and passcode.</p>
              </div>

              <div className="mb-3">
                <label>Email Address</label>
                <div className="position-relative">
                  <span className="input-icon-addon">
                    <i className="ti ti-mail"></i>
                  </span>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="john.doe@example.com"
                    required
                  />
                </div>
              </div>

              <div className="mb-3">
                <label>Password</label>
                <div className="pass-group">
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    className="pass-input form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="*********"
                    required
                  />
                  <span
                    className={`ti toggle-password ${
                      isPasswordVisible ? "ti-eye" : "ti-eye-off"
                    }`}
                    onClick={togglePasswordVisibility}
                  ></span>
                </div>
              </div>

              {message && (
                <div
                  className={`alert ${
                    message.toLowerCase().includes("success")
                      ? "alert-success"
                      : "alert-danger"
                  }`}
                >
                  {message}
                </div>
              )}

              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="form-check form-check-md">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultChecked
                  />
                  <label>Remember Me</label>
                </div>

                <Link to="/forgot-password" className="text-primary fw-medium">
                  Forgot Password?
                </Link>
              </div>

              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Signing In...
                  </>
                ) : (
                  "Sign In"
                )}
              </button>

              <div className="text-center my-3">or</div>

              {/* MAGIC LINK BUTTON */}
              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={() => setShowEmailModal(true)}
              >
                Login with Magic Link
              </button>

              <div className="mt-3">
                <h6>
                  New on our platform?
                  <Link to="/register" className="text-purple">
                    {" "}
                    Create an account
                  </Link>
                </h6>
              </div>

              <div className="text-center mt-4">
                <p className="fw-medium text-gray">
                  Copyright © 2025 - Voycell
                </p>
              </div>
            </div>
          </form>
        </div>

        <div className="w-50 vh-100 account-bg-01"></div>
      </div>

      {/* ======================= */}
      {/* MAGIC LINK MODAL #1 */}
      {/* ======================= */}
      {showEmailModal && (
        <div
          className="modal fade show d-block"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Enter Your Email</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowEmailModal(false)}
                />
              </div>

              <div className="modal-body">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control mb-3"
                  value={magicEmail}
                  onChange={(e) => setMagicEmail(e.target.value)}
                />

                <button
                  className="btn btn-primary w-100"
                  onClick={handleSendMagicLink}
                  disabled={magicLoading}
                >
                  {magicLoading ? "Sending..." : "Send Magic Link"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ======================= */}
      {/* MAGIC LINK MODAL #2 */}
      {/* ======================= */}
      {showLinkModal && (
        <div
          className="modal fade show d-block"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Paste Magic Link</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowLinkModal(false)}
                />
              </div>

              <div className="modal-body">
                <label className="mb-2">Magic Link</label>
                <textarea
                  className="form-control mb-3"
                  rows="3"
                  value={magicLink}
                  onChange={(e) => setMagicLink(e.target.value)}
                />

                {magicMessage && (
                  <div className="alert alert-info">{magicMessage}</div>
                )}

                <button
                  className="btn btn-success w-100"
                  onClick={handleVerifyMagicLink}
                  disabled={magicLoading}
                >
                  {magicLoading ? "Verifying..." : "Verify & Login"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
